import { useFormSelector } from 'mrf/redux/ReduxHelper';
import CheckboxField from 'mrf/view/CheckboxField';
import FormCRUD from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import QueryObjectField from 'mrf/view/QueryObjectField';
import TextField from 'mrf/view/TextField';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function InstitutionForm({ history, match }) {

    const {t} = useTranslation();

    const context = useFormSelector({
        id: match?.params?.id,
        resource: 'institutions',
        endpoint: `/api/institutions/${match?.params?.id}`
    });
    
    const countryFields = [
        { name: 'Name', key: 'name' },
        { name: 'Code', key: 'abbreviation' },
    ];

    return <FormCRUD
        title='Institution'
        match={match}
        history={history}
        context={context}
    >
        <Grid>
            <Col size={3}>
                <QueryObjectField
                    label={t('Country')}
                    resource='countries'
                    endpoint={'/api/countries'}
                    displayAttribute='name'
                    field='countryId'
                    fields={countryFields}
                    formEndpoint='/api/institutions'
                    disableRemove
                    disableAdd
                    required
                />
            </Col>
            <Col size={6}>
                <TextField
                    label='Name'
                    field='name'
                />
            </Col>
            <Col size={3}>
                <TextField
                    label='Code'
                    field='code'
                />
            </Col>
            <Col size={2}>
                <CheckboxField
                    label={t('Can import')}
                    field='importer'
                />
            </Col>
            <Col size={2}>
                <CheckboxField
                    label={t('Can export')}
                    field='exporter'
                />
            </Col>
            <Col size={2}>
                <CheckboxField
                    label={t('Participates in MCTA')}
                    field='isInMcta'
                />
            </Col>
        </Grid>
    </FormCRUD>
}